import {useSelector} from 'react-redux'
import {getSearchParameters} from 'modules/sapiSearch/selectors'
import {omitMetaLandingToken} from 'modules/sapiSearch/utils'
import {getIsLandingItinerary} from 'modules/search/selectors'

/**
 * Search metadata for a carousel request. The meta landing token only works
 * for the hotel and dates the user landed on, so any other request keeps the
 * attribution part only.
 */
export const useMetadataForItinerary = (
  hotelId?: string,
  checkIn?: string,
  checkOut?: string
) => {
  const {metadata} = useSelector(getSearchParameters) || {}
  const canCarryLandingToken = useSelector(state =>
    getIsLandingItinerary(state, hotelId, checkIn, checkOut)
  )

  return canCarryLandingToken ? metadata : omitMetaLandingToken(metadata)
}
